module.exports = __webpack_public_path__ + "img/IMG_0971.6ac035c5.jpg";